import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { activitesApi } from '../api/activites.api'
import type { CreateActivityDto } from '@/shared/types/activite'

const QUERY_KEY = ['activites']

export function useActivites(etudiantId: number | undefined) {
  return useQuery({
    queryKey: [...QUERY_KEY, etudiantId],
    queryFn: () => activitesApi.getByEtudiantId(etudiantId!),
    enabled: !!etudiantId,
  })
}

export function useCreateActivite(etudiantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: CreateActivityDto) => activitesApi.create(etudiantId, data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [...QUERY_KEY, etudiantId] })
      qc.invalidateQueries({ queryKey: ['planning', etudiantId] })
    },
  })
}

export function useDeleteActivite(etudiantId: number) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (activityId: number) => activitesApi.delete(activityId, etudiantId),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: [...QUERY_KEY, etudiantId] })
      qc.invalidateQueries({ queryKey: ['planning', etudiantId] })
    },
  })
}
